import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../../components';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';
import { request } from '../../../../../../utils';
import { toast } from '../../../../../../utils';

export const ProductmasterDetailsForm = ({ onClose, setProductDialogue, setMedicine, getMedicineDropdown }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        main: Yup.object().shape({
          name: Yup.string().required(' ')
        })
      })
    ),
    defaultValues: {
      conversion: 1,
      packing: 1
    },
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = async (formValues) => {
    const response = await request('/product-master-create', {
      method: 'POST',
      body: {
        ...formValues
      }
    });
    if (response?.success) {
      toast('Successfully created Product master', { variant: 'success' });
      setMedicine((prev) => [...prev, { name: formValues.main.name }]);
      setProductDialogue(false);
      getMedicineDropdown();
    } else {
      toast('Failed to create Product master', { variant: 'error' });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
        <Grid item>
          <Typography fontWeight="bold" fontSize="14px" color="red">
            Add Product
          </Typography>
        </Grid>
        <TextField name="main.name" />
      </Grid>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
